const FilterBar = ({ searchValue, onSearchChange, searchPlaceholder = "Search…", filters, children }) => (
  <div className="dashboard-filter-bar">
    {onSearchChange && (
      <input
        type="search"
        value={searchValue || ""}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={searchPlaceholder}
        aria-label="Search"
      />
    )}
    {filters}
    {children}
  </div>
);

export default FilterBar;
